import { HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type SpinnerProps = HTMLAttributes<HTMLDivElement> & {
  variant?: 'small' | 'medium'
}

const Spinner = ({ className, variant = 'medium', ...props }: SpinnerProps) => {
  return (
    <span
      className={cn([
        'block animate-rotate',
        {
          'h-[1.8rem] w-[1.8rem]': variant === 'small',
          'h-[3rem] w-[3rem]': variant === 'medium'
        },
        className
      ])}
      {...props}
    >
      <svg viewBox="25 25 50 50" className="animate-spin">
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth={variant === 'small' ? 6 : 3}
          strokeMiterlimit="10"
        />
      </svg>
    </span>
  )
}

export default Spinner
